export const sharedUrls = {
  wwwRoot: 'https://www.mvphealthcare.com'
};